import { z } from 'zod';
import { currencyCodeSchema, decimalStringSchema, isoDateSchema, positiveDecimalSchema } from './common';

export const assetTypeSchema = z.enum([
  'real_estate',
  'vehicle',
  'investment',
  'crypto',
  'cash_equivalent',
  'collectible',
  'business',
  'other',
]);
export type AssetType = z.infer<typeof assetTypeSchema>;

export const liabilityTypeSchema = z.enum([
  'mortgage',
  'consumer_loan',
  'auto_loan',
  'student_loan',
  'credit_card_debt',
  'personal_debt',
  'tax_debt',
  'other',
]);
export type LiabilityType = z.infer<typeof liabilityTypeSchema>;

export const createAssetSchema = z.object({
  name: z.string().min(1).max(200),
  type: assetTypeSchema,
  value: positiveDecimalSchema,
  currency: currencyCodeSchema.default('EUR'),
  purchaseDate: isoDateSchema.optional(),
  purchaseValue: decimalStringSchema.optional(),
  note: z.string().max(2000).optional(),
  includeInNetWorth: z.boolean().optional().default(true),
});
export type CreateAssetInput = z.infer<typeof createAssetSchema>;

export const updateAssetSchema = createAssetSchema.partial();
export type UpdateAssetInput = z.infer<typeof updateAssetSchema>;

export const createLiabilitySchema = z.object({
  name: z.string().min(1).max(200),
  type: liabilityTypeSchema,
  amount: positiveDecimalSchema,
  currency: currencyCodeSchema.default('EUR'),
  interestRate: z.coerce.number().min(0).max(100).optional(),
  monthlyPayment: decimalStringSchema.optional(),
  startsOn: isoDateSchema.optional(),
  endsOn: isoDateSchema.optional(),
  note: z.string().max(2000).optional(),
  includeInNetWorth: z.boolean().optional().default(true),
});
export type CreateLiabilityInput = z.infer<typeof createLiabilitySchema>;

export const updateLiabilitySchema = createLiabilitySchema.partial();
export type UpdateLiabilityInput = z.infer<typeof updateLiabilitySchema>;
